import React from "react";
import { PageShell } from "../components/Layout";
import SeoContent from "../components/SeoContent";
import { api } from "../services/api";
import useSeo from "../hooks/useSeo";

const PAGE_SIZE = 60;

export default function PreviousResult() {
  const [items, setItems] = React.useState([]);
  const [total, setTotal] = React.useState(0);
  useSeo({
    title: "Sunday Ground Teer Previous Result 2019 to 2026 | Full Archive",
    description:
      "Complete Sunday Ground / Shillong Teer Previous Result archive from 2019 to 2026 with F/R and S/R numbers. Filter by year and study past teer results.",
  });
  const [year, setYear] = React.useState("all");
  const [years, setYears] = React.useState(["all"]);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    api.resultYears().then((ys) => setYears(["all", ...ys])).catch(() => {});
  }, []);

  const load = React.useCallback((yr, skip, append) => {
    setLoading(true);
    api
      .results({ year: yr, limit: PAGE_SIZE, skip })
      .then((data) => {
        setTotal(data.total);
        setItems((prev) => (append ? [...prev, ...data.items] : data.items));
      })
      .finally(() => setLoading(false));
  }, []);

  React.useEffect(() => {
    load(year, 0, false);
  }, [year, load]);

  return (
    <>
      <PageShell title="Previous Result" subtitle="Sunday Ground / Shillong Teer Result Archive (2019 - 2026)">
        <div className="flex flex-wrap gap-2 justify-center mb-5">
          {years.map((y) => (
            <button
              key={y}
              onClick={() => setYear(y)}
              className={`px-3.5 py-1.5 rounded-full text-sm font-bold border transition-colors ${
                year === y
                  ? "bg-[#e8491d] text-white border-[#e8491d]"
                  : "bg-white text-gray-600 border-gray-300 hover:border-[#e8491d]"
              }`}
            >
              {y === "all" ? "All" : y}
            </button>
          ))}
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden max-w-3xl mx-auto">
          <div className="text-center font-black py-2.5 bg-gray-100 border-b border-gray-200 text-[#1f2733]">
            RESULTS
          </div>
          <div className="grid grid-cols-4 bg-[#3bd4bd] font-bold text-sm border-b border-gray-300">
            <div className="py-2 px-3">CITY</div>
            <div className="py-2 px-3 text-center">DATE</div>
            <div className="py-2 px-3 text-center">F/R</div>
            <div className="py-2 px-3 text-center">S/R</div>
          </div>
          {items.map((r, i) => (
            <div
              key={r.id || r.date}
              className={`grid grid-cols-4 text-sm border-b border-gray-100 ${
                i % 2 ? "bg-gray-50" : "bg-white"
              }`}
            >
              <div className="py-1.5 px-3 text-gray-700">{r.city}</div>
              <div className="py-1.5 px-3 text-center text-gray-700">{r.date}</div>
              <div className="py-1.5 px-3 text-center font-bold">{r.fr}</div>
              <div className="py-1.5 px-3 text-center font-bold">{r.sr}</div>
            </div>
          ))}
          {items.length === 0 && !loading && (
            <div className="py-8 text-center text-gray-400 text-sm">No results found.</div>
          )}
        </div>

        {items.length < total && (
          <div className="text-center mt-5">
            <button
              disabled={loading}
              onClick={() => load(year, items.length, true)}
              className="px-6 py-2.5 rounded-xl bg-[#e8491d] text-white font-bold hover:bg-[#c53a12] transition-colors disabled:opacity-60"
            >
              {loading ? "Loading..." : `Load More (${total - items.length} left)`}
            </button>
          </div>
        )}
      </PageShell>
      <SeoContent variant="previous" />
    </>
  );
}
